import { type MetaFunction } from '@remix-run/node'
import programBusiness from './program-business.png'

export const meta: MetaFunction = () => [
	{ title: 'Business Insurance' },
	{
		name: 'description',
		content: 'We offer Business Insurance.',
	},
]

export default function Component() {
	return (
		<main className="mx-auto my-10 max-w-7xl">
			<h1 className="py-3 text-4xl font-black">Business Insurance</h1>
			<img
				src={programBusiness}
				alt="A laptop computer on a desk with other office supplies."
				className="rounded-lg object-cover object-center"
			/>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				Each business has unique needs. We offer the following coverages to meet
				the insurance needs of your business:
				<ul>
					<li>General Liability</li>
					<li>Product(s) Liability</li>
					<li>Professional Liability</li>
					<li>Commercial Automobile Liability</li>
					<li>Liquor Liability</li>
					<li>Employment Practices Liability</li>
					<li>Environmental Practices Liability</li>
					<li>Directors &amp; Officers Liability</li>
					<li>Commercial Umbrella Liability</li>
					<li>Commercial Property</li>
					<li>Workers' Compensation</li>
					<li>NY State Disability</li>
					<li>Business Interruption</li>
					<li>Crime</li>
					<li>Inland Marine</li>
					<li>Bonds</li>
					<li>Cyber Liability</li>
					<li>Medical Insurance</li>
					<li>Life</li>
				</ul>
			</p>
		</main>
	)
}
